import api from "@helpers/api";
import { URLS } from "@constants/urls";
import { DECISION_TYPE } from "@constants/workflow-decision-type";

const { START_WORKFLOW, EXECUTE_WORKFLOW } = URLS;
const { INITIATE, FORWARD } = DECISION_TYPE;

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_WORKFLOW_BASE_URL}${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_WORKFLOW_PORT}/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_WORKFLOW}/api/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_WORKFLOW_VERSION}/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_WORKFLOW_TYPE}/procurements`;

const apiEndPointForEmployees = `${process.env.REACT_APP_EMPLOYEE_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${URLS.EMPLOYEES}/commoninfo`;

export const fetchPositionCode = async () => {
  const res = await api.get(`${apiEndPoint}/flow-initial`);
  return res;
};

export const fetchEmployees = async (positionCode: string) => {
  const res = await api.get(apiEndPointForEmployees, {
    params: {
      positionCode,
    },
  });
  return res;
};

export const startWorkflow = async (
  id: number | string,
  nextFileOnHandId: number,
) => {
  const res = await api.post(`${apiEndPoint}/${id}/${START_WORKFLOW}`, {
    decisionType: INITIATE,
    nextFileOnHandId,
  });
  return res;
};

export const executeWorkflow = async (
  id: number | string,
  decisionType: string,
  processInstanceId: string,
  nextFileOnHandId?: number,
  comment?: string,
) => {
  const res = await api.post(`${apiEndPoint}/${id}/${EXECUTE_WORKFLOW}`, {
    decisionType,
    nextFileOnHandId,
    processInstanceId,
    comment,
  });
  return res;
};
